import React, { useEffect } from "react";

import { Col, Form, Input, Modal, Row, Button, Icon } from "antd";

import LoadingIndicator from "components/LoadingIndicator";

import { connect } from "react-redux";

import SelectOriginatorRxComponent from "rxcomponents/common/SelectOriginatorRxComponent";
import SelectRelationshipRxComponent from "rxcomponents/common/SelectRelationshipRxComponent";
import SelectSourceOfFundRxComponent from "rxcomponents/common/SelectSourceOfFundRxComponent";
import SelectPurposeOfTransferRxComponent from "rxcomponents/common/SelectPurposeOfTransferRxComponent";
import DocumentUploadRxModal from "rxcomponents/modal/DocumentUploadRxModal";

import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";
import { formatDouble } from "utils/utils";

import {
  displayError,
  displayGenericError,
  displaySuccessMessage,
} from "common/notifications";

import {
  cleanup,
  setModalVisible,
  setOriginator,
  setOriginatorId,
  setClientFeeAmount,
  setSettlementAmountMinusFee,
  setValidateStatus,
  getOriginator,
  getBankTransactionLinks,
} from "rx/addvasettle";

import {
  setModalVisible as setDocumentUploadModalVisible,
  cleanup as documentUploadModalCleanup,
} from "rx/documentupload";

import { createVaSettleOrder, uploadInvoice } from "api/api";

const confirm = Modal.confirm;

function VaSettleRxModal(props) {
  const intl = useIntl();

  useEffect(() => {
    props.setOriginatorId(props.originatorId);
    props.getOriginator(props.originatorId);
  }, [props.originatorId]);

  useEffect(() => {
    props.getBankTransactionLinks(props.fundId);
  }, [props.fundId]);

  useEffect(() => {
    var settlementAmount = props.settlementAmount;
    if (props.bankTransactionLinks.length > 0) {
      let linkBankFee = props.bankTransactionLinks[0].linkBankFee;
      if (linkBankFee) {
        props.setSettlementAmountMinusFee(settlementAmount - linkBankFee);
      } else {
        props.setSettlementAmountMinusFee(settlementAmount);
      }
    } else {
      props.setSettlementAmountMinusFee(settlementAmount);
    }
  }, [props.bankTransactionLinks]);

  return (
    <>
      <Modal
        width={1000}
        className="vaSettleModal"
        visible={props.modalVisible}
        onOk={() => {
          handleOk(props, intl);
        }}
        onCancel={() => {
          props.cleanup();
          props.documentUploadModalCleanup();
        }}
        title={intl.formatMessage({
          id: "app.modal.vasettlerxmodal.vasettlement",
        })}
      >
        {props.loading && <LoadingIndicator />}
        <Row gutter={16}>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.fundid",
              })}
            >
              <label>
                <b>
                  {props.mutualCreditFundId
                    ? props.mutualCreditFundId
                    : props.fundId}
                </b>
              </label>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.virtualaccountname",
              })}
            >
              <label>
                <b>{props.virtualAccountName}</b>
              </label>
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.virtualaccountnumber",
              })}
            >
              <label>
                <b>{props.virtualAccountNumber}</b>
              </label>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.originator",
              })}
              validateStatus={props.validateStatus.originator}
              help={
                props.validateStatus.originator === "error"
                  ? intl.formatMessage({
                      id: props.validateStatus.originatorErrorMsg,
                    })
                  : ""
              }
            >
              <SelectOriginatorRxComponent style={{ width: "300px" }} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.originatortype",
              })}
            >
              <Input
                size="large"
                name="originatorType"
                value={props.originator ? props.originator.originatorType : ""}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}></Col>
        </Row>
        {props.originator && props.originator.originatorType === "CORPORATE" && (
          <>
            <Row gutter={16}>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.businessname",
                  })}
                  validateStatus={props.validateStatus.businessName}
                  help={
                    props.validateStatus.businessName === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.businessNameErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="businessName"
                    value={
                      props.originator ? props.originator.businessName : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.incorporatedcountry",
                  })}
                  validateStatus={props.validateStatus.incorporatedCountry}
                  help={
                    props.validateStatus.incorporatedCountry === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.incorporatedCountryErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="countryIncorporatedName"
                    value={
                      props.originator
                        ? props.originator.countryIncorporatedName
                        : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.businessnumber",
                  })}
                  validateStatus={props.validateStatus.businessNumber}
                  help={
                    props.validateStatus.businessNumber === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.businessNumberErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="businessNumber"
                    value={
                      props.originator ? props.originator.businessNumber : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.dateofincorporation",
                  })}
                  validateStatus={props.validateStatus.dateOfIncorporation}
                  help={
                    props.validateStatus.dateOfIncorporation === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.dateOfIncorporationErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="dateOfIncorporation"
                    value={
                      props.originator && props.originator.dob
                        ? moment(props.originator.dob).format("DD/MM/YYYY")
                        : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.businessnature",
                  })}
                  validateStatus={props.validateStatus.industry}
                  help={
                    props.validateStatus.industry === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.industryErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="industry"
                    value={
                      props.originator ? props.originator.industryName : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
          </>
        )}
        {props.originator && props.originator.originatorType === "INDIVIDUAL" && (
          <>
            <Row gutter={16}>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.sendername",
                  })}
                  validateStatus={props.validateStatus.senderName}
                  help={
                    props.validateStatus.senderName === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.senderNameErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="displayName"
                    value={props.originator ? props.originator.displayName : ""}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.countryofresidence",
                  })}
                  validateStatus={props.validateStatus.countryOfResidence}
                  help={
                    props.validateStatus.countryOfResidence === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.countryOfResidenceErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="countryOfResidenceName"
                    value={
                      props.originator
                        ? props.originator.countryOfResidenceName
                        : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.idnumber",
                  })}
                  validateStatus={props.validateStatus.idNumber}
                  help={
                    props.validateStatus.idNumber === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.idNumberErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="idNumber"
                    value={props.originator ? props.originator.idNumber : ""}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}>
                <Form.Item
                  label={intl.formatMessage({
                    id: "app.modal.vasettlerxmodal.dateofbirth",
                  })}
                  validateStatus={props.validateStatus.dateOfBirth}
                  help={
                    props.validateStatus.dateOfBirth === "error"
                      ? intl.formatMessage({
                          id: props.validateStatus.dateOfBirthErrorMsg,
                        })
                      : ""
                  }
                >
                  <Input
                    size="large"
                    name="dateOfBirth"
                    value={
                      props.originator && props.originator.dob
                        ? moment(props.originator.dob).format("DD/MM/YYYY")
                        : ""
                    }
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col className="gutter-row" span={8}></Col>
            </Row>
          </>
        )}
        <Row gutter={16}>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.relationship",
              })}
              validateStatus={props.validateStatus.relationship}
              help={
                props.validateStatus.relationship === "error"
                  ? intl.formatMessage({
                      id: props.validateStatus.relationshipErrorMsg,
                    })
                  : ""
              }
            >
              <SelectRelationshipRxComponent style={{ width: "300px" }} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.sourceoffund",
              })}
              validateStatus={props.validateStatus.sourceOfFund}
              help={
                props.validateStatus.sourceOfFund === "error"
                  ? intl.formatMessage({
                      id: props.validateStatus.sourceOfFundErrorMsg,
                    })
                  : ""
              }
            >
              <SelectSourceOfFundRxComponent style={{ width: "300px" }} />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.purposeoftransfer",
              })}
              validateStatus={props.validateStatus.purposeOfTransfer}
              help={
                props.validateStatus.purposeOfTransfer === "error"
                  ? intl.formatMessage({
                      id: props.validateStatus.purposeOfTransferErrorMsg,
                    })
                  : ""
              }
            >
              <SelectPurposeOfTransferRxComponent style={{ width: "300px" }} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.settlementcurrency",
              })}
            >
              <Input
                size="large"
                name="settlementCurrency"
                value={props.settlementCurrency}
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage(
                { id: "app.modal.vasettlerxmodal.clientfeeamount" },
                {
                  customerName: props.customer.corporateAccountDetails
                    ? props.customer.corporateAccountDetails.nameOfBusiness
                    : "",
                }
              )}
              validateStatus={props.validateStatus.clientFeeAmount}
              help={
                props.validateStatus.clientFeeAmount === "error"
                  ? intl.formatMessage({
                      id: props.validateStatus.clientFeeAmountErrorMsg,
                    })
                  : ""
              }
            >
              <Input
                size="large"
                name="clientFeeAmount"
                onChange={(e) => {
                  props.setClientFeeAmount(e.target.value);
                }}
                value={props.clientFeeAmount}
              />
            </Form.Item>
          </Col>
          <Col className="gutter-row" span={8}>
            <Form.Item
              label={intl.formatMessage({
                id: "app.modal.vasettlerxmodal.settlementamount",
              })}
            >
              <Input
                size="large"
                name="settlementAmount"
                value={props.settlementAmountMinusFee}
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col className="gutter-row" span={24}>
            {props.uploadedFileTypes.length > 0 && (
              <table className="documentUploadTable">
                <tr>
                  <th style={{ width: "60px" }}>
                    <FormattedMessage id="app.common.index" />
                  </th>
                  <th>
                    <FormattedMessage id="app.common.document.type" />
                  </th>
                  <th>
                    <FormattedMessage id="app.common.file.name" />
                  </th>
                  <th>
                    <FormattedMessage id="app.common.file.size" />
                  </th>
                  <th>
                    <FormattedMessage id="app.common.file" />
                  </th>
                </tr>
                {props.uploadedFileTypes.map((uploadedFileType, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{uploadedFileType}</td>
                      <td>{props.uploadedFilenames[index]}</td>
                      <td>
                        {formatDouble(props.uploadedFileSizes[index] / 1024, 0)}
                        kb
                      </td>
                      <td>
                        <a target="_blank" href={props.uploadedFiles[index]}>
                          <FormattedMessage id="app.common.download" />
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </table>
            )}
          </Col>
        </Row>
        <Row style={{ marginTop: "40px" }} gutter={16}>
          <Col className="gutter-row" span={8}>
            <Button
              type="primary"
              onClick={() => props.setDocumentUploadModalVisible(true)}
              style={{ marginLeft: "10px" }}
              icon="upload"
            >
              {" "}
              <FormattedMessage id="app.panel.orderdetailspanel.uploadordragproof" />
            </Button>
          </Col>
        </Row>
        <DocumentUploadRxModal />
      </Modal>
    </>
  );
}

const handleOk = (props, intl) => {
  var validateStatus = { ...props.validateStatus };
  var validateError = false;
  if (!props.originator) {
    validateStatus.originator = "error";
    validateError = true;
  }

  if (!props.relationship) {
    validateStatus.relationship = "error";
    validateError = true;
  }
  if (!props.purposeOfTransfer) {
    validateStatus.purposeOfTransfer = "error";
    validateError = true;
  }
  if (!props.sourceOfFund) {
    validateStatus.sourceOfFund = "error";
    validateError = true;
  }

  if (props.originator && props.originator.originatorType === "CORPORATE") {
    if (!props.originator.industry) {
      validateStatus.industry = "error";
      validateError = true;
    }
    if (!props.originator.businessName) {
      validateStatus.businessName = "error";
      validateError = true;
    }
    if (!props.originator.countryIncorporated) {
      validateStatus.incorporatedCountry = "error";
      validateError = true;
    }
    if (!props.originator.businessNumber) {
      validateStatus.businessNumber = "error";
      validateError = true;
    }
    if (!props.originator.dob) {
      validateStatus.dateOfIncorporation = "error";
      validateError = true;
    }
  }

  if (props.originator && props.originator.originatorType === "INDIVIDUAL") {
    if (!props.originator.displayName) {
      validateStatus.senderName = "error";
      validateError = true;
    }
    if (!props.originator.countryOfResidence) {
      validateStatus.countryOfResidence = "error";
      validateError = true;
    }
    if (!props.originator.idNumber) {
      validateStatus.idNumber = "error";
      validateError = true;
    }
    if (!props.originator.dob) {
      validateStatus.dateOfBirth = "error";
      validateError = true;
    }
  }

  if (props.clientFeeAmount < 0 || props.clientFeeAmount === "") {
    validateStatus.clientFeeAmount = "error";
    validateError = true;
  }

  if (validateError) {
    props.setValidateStatus(validateStatus);
    return;
  }

  confirm({
    title: (
      <p>
        {intl.formatMessage({
          id: "app.modal.vasettlerxmodal.areyousureyouwanttocreatevasettlement",
        })}
      </p>
    ),
    onOk: async () => {
      let params = {
        fundId: props.fundId,
        mutualCreditFundId: props.mutualCreditFundId,
        originatorId: props.originatorId,
        virtualAccountNumber: props.virtualAccountNumber,
        virtualAccountName: props.virtualAccountName,
        settlementCurrency: props.settlementCurrency,
        settlementAmount: props.settlementAmountMinusFee,
        clientFeeAmount: props.clientFeeAmount,
        purposeOfTransfer: props.purposeOfTransfer,
        sourceOfFund: props.sourceOfFund,
        relationship: props.relationship,
        relationshipRemark: props.relationshipRemark,
      };
      //console.log(params);

      try {
        const response = await createVaSettleOrder(params);
        //console.log(response);

        var orderId = response.id;

        for (var i = 0; i < props.uploadedFiles.length; i++) {
          let fileFetched = await fetch(props.uploadedFiles[i])
            .then((r) => r.blob())
            .then(
              (blobFile) =>
                new File([blobFile], props.uploadedFilenames[i], {
                  type: blobFile.type,
                })
            );
          //console.log(fileFetched);

          var invoice = {
            id: orderId,
            fileType: props.uploadedFileTypes[i],
            remarks: props.uploadedFileTypes[i],
            file: fileFetched,
            otherTypeDescription: "",
          };

          await uploadInvoice(invoice);
        }

        //props.setModalVisible(false);
        props.cleanup();
        props.documentUploadModalCleanup();
        window.location.reload();

        //displaySuccessMessage("Va Settlement is created.");
      } catch (error) {
        console.error(error.message);
        if (error.message) {
          displayError(error.message);
          return;
        }
        displayGenericError(error.message);
      }
    },
  });
};

const mapStateToProps = (state) => {
  return {
    modalVisible: state.addVaSettle.modalVisible,
    originator: state.addVaSettle.originator,
    fundId: state.addVaSettle.fundId,
    bankTransactionLinks: state.addVaSettle.bankTransactionLinks,
    mutualCreditFundId: state.addVaSettle.mutualCreditFundId,
    virtualAccountName: state.addVaSettle.virtualAccountName,
    virtualAccountNumber: state.addVaSettle.virtualAccountNumber,
    settlementAmount: state.addVaSettle.settlementAmount,
    settlementAmountMinusFee: state.addVaSettle.settlementAmountMinusFee,
    clientFeeAmount: state.addVaSettle.clientFeeAmount,
    settlementCurrency: state.addVaSettle.settlementCurrency,
    validateStatus: state.addVaSettle.validateStatus,
    loading: state.addVaSettle.loading,
    originatorId: state.selectOriginator.originatorId,
    originator: state.addVaSettle.originator,
    purposeOfTransfer: state.selectPurposeOfTransfer.purposeOfTransfer,
    sourceOfFund: state.selectSourceOfFund.sourceOfFund,
    relationship: state.selectRelationship.relationship,
    relationshipRemark: state.selectRelationship.relationshipRemark,

    uploadedFileTypes: state.documentUpload.uploadedFileTypes,
    uploadedFiles: state.documentUpload.uploadedFiles,
    uploadedFilenames: state.documentUpload.uploadedFilenames,
    uploadedFileSizes: state.documentUpload.uploadedFileSizes,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    cleanup: () => dispatch(cleanup()),
    documentUploadModalCleanup: () => dispatch(documentUploadModalCleanup()),
    setModalVisible: (modalVisible) => dispatch(setModalVisible(modalVisible)),
    setDocumentUploadModalVisible: (modalVisible) =>
      dispatch(setDocumentUploadModalVisible(modalVisible)),
    setOriginatorId: (originatorId) => dispatch(setOriginatorId(originatorId)),
    setOriginator: (originator) => dispatch(setOriginator(originator)),
    setClientFeeAmount: (clientFeeAmount) =>
      dispatch(setClientFeeAmount(clientFeeAmount)),
    setSettlementAmountMinusFee: (settlementAmountMinusFee) =>
      dispatch(setSettlementAmountMinusFee(settlementAmountMinusFee)),
    setValidateStatus: (validateStatus) =>
      dispatch(setValidateStatus(validateStatus)),
    getOriginator: (originatorId) => dispatch(getOriginator(originatorId)),
    getBankTransactionLinks: (fundId) =>
      dispatch(getBankTransactionLinks(fundId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VaSettleRxModal);
